import { HomeFundInfoserviceSection, HomeFundIntroductionSection, HomeFundServiceSection, LinkSection, OverviewSection } from '@components/pageSection';

export const TypeMap: Record<string, React.ComponentType<any>> = {
  LinkSection,
  OverviewSection,
  HomeFundIntroduction: HomeFundIntroductionSection,
  HomeFundService: HomeFundServiceSection,
  HomeFundInfoservice: HomeFundInfoserviceSection,
};
